const MAX_CENTS = BigInt(Number.MAX_SAFE_INTEGER);
const invalid = () => { throw new Error('Informe um valor em reais, não negativo, com até duas casas decimais e dentro do limite permitido.'); };
const validCents = value => Number.isSafeInteger(value) && value >= 0;

export function parseBRL(value) {
  if (typeof value !== 'string') return invalid();
  const text = value.trim().replace(/^R\$\s*/, '');
  if (!text && !value.trim()) return null;
  if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(text)) return invalid();
  const [whole, fraction = ''] = text.replace(/\./g, '').split(',');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  if (cents > MAX_CENTS) return invalid();
  return Number(cents);
}

export function formatCents(value) {
  if (value == null) return '';
  if (!validCents(value)) return invalid();
  const cents = BigInt(value);
  return `${String(cents / 100n).replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${String(cents % 100n).padStart(2, '0')}`;
}

export function distributeCents(total, count) {
  if (!validCents(total) || !Number.isInteger(count) || count < 1 || count > 120) return invalid();
  const quotient = BigInt(total) / BigInt(count);
  const remainder = BigInt(total) % BigInt(count);
  return Array.from({ length: count }, (_, index) => Number(quotient + (BigInt(index) < remainder ? 1n : 0n)));
}

export function listMonths({ startMonth, endMonth } = {}) {
  const ordinal = value => {
    if (typeof value !== 'string' || !/^[1-9]\d{3}-(0[1-9]|1[0-2])$/.test(value)) throw new Error('Informe um período válido de até 120 meses.');
    const [year, month] = value.split('-').map(Number);
    return year * 12 + month - 1;
  };
  const first = ordinal(startMonth), last = ordinal(endMonth);
  if (last < first || last - first >= 120) throw new Error('Informe um período válido de até 120 meses.');
  return Array.from({ length: last - first + 1 }, (_, index) => {
    const month = first + index;
    return `${Math.floor(month / 12)}-${String(month % 12 + 1).padStart(2, '0')}`;
  });
}

export const cellCoordinate = (scopeId, month) => JSON.stringify([scopeId, month]);
export function makeCell(cells, costScopeId, budgetMonth, plannedCents) {
  const existing = cells.find(cell => cell.costScopeId === costScopeId && cell.budgetMonth === budgetMonth);
  return { cellId: existing?.cellId || `cell:${cellCoordinate(costScopeId, budgetMonth)}`, costScopeId, budgetMonth, plannedCents };
}
